import { render, staticRenderFns } from "./the-preview-dialog.vue?vue&type=template&id=081c17c6&scoped=true&"
import script from "./the-preview-dialog.vue?vue&type=script&lang=js&"
export * from "./the-preview-dialog.vue?vue&type=script&lang=js&"
import style0 from "./the-preview-dialog.vue?vue&type=style&index=0&id=081c17c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081c17c6",
  null
  
)

export default component.exports